<template>
  <v-card class="mt-5" outlined>
    <v-card-title>
      {{ $t('project.contacts._') }}
      <v-spacer/>
      <v-btn icon @click="$emit('add')">
        <v-icon>mdi mdi-plus</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-divider class="mb-0" style="border-color: #000;"/>
    </v-card-text>
    <v-card-text v-if="!contacts || contacts.length === 0">
      <v-row>
        <v-col>{{ $t('project.contacts.no_contacts') }}</v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-for="(contact, i) in contacts" :key="contact._id">
      <v-divider v-if="i > 0" class="mb-6 mt-n7"></v-divider>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="contact.name"
            :disabled="saving"
            :label="$t('project.contacts.name')"
            autocomplete="off"
            dense
            hide-details
            light
            outlined
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="9" md="11">
              <v-text-field
                v-model="contact.role"
                :disabled="saving"
                :label="$t('project.contacts.role')"
                autocomplete="off"
                dense
                hide-details
                light
                outlined
              >
              </v-text-field>
            </v-col>
            <v-col class="justify-end d-flex" cols="3" md="1">
              <v-btn :loading="contact._loading" color="error" icon tabindex="-1"
                     @click="$emit('delete', contact)">
                <v-icon>mdi mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="contact.phone"
            :disabled="saving"
            :label="$t('project.contacts.phone')"
            autocomplete="off"
            dense
            hide-details
            item-value=""
            light
            outlined
            validate-on-blur
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="contact.email"
            :disabled="saving"
            :label="$t('project.contacts.email')"
            :rules="[$rules.email, $rules.spacesNotAllowed]"
            autocomplete="off"
            dense
            item-value=""
            light
            outlined
            validate-on-blur
          >
          </v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ProjectContactsCard',
  props: {
    contacts: {
      type: Array,
      default: () => []
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  emits: ['add', 'delete']
}
</script>
